export default {"src":"/_next/static/media/logoBlock6.98b17317.svg","height":77,"width":157,"blurWidth":0,"blurHeight":0};